import { Address } from '@/types/Types'
import authModule from '@/store/auth'
import dashboardModule from '@/store/dashboard'
import axios from 'axios'
import { isEqual } from 'lodash'

export async function uploadFile(
  file: File | File[],
  url: string,
  fieldName: string
) {
  if (!authModule.user) return
  const formData = new FormData()

  if (file instanceof File) {
    formData.append(fieldName, file)
  } else {
    file.forEach(el => {
      formData.append(fieldName, el)
    })
  }

  const { data } = await axios.post(url, formData)

  return data
}

export async function uploadImage(file: File | File[]) {
  if (!authModule.user) return
  try {
    const response = await uploadFile(
      file,
      `/admin/${authModule.user.whitelabel.slug ||
        authModule.user.whitelabel}/meta/mediaUpload`,
      'photos'
    )
    return response.result
  } catch (err) {
    dashboardModule.newError('Datei konnte nicht hochgeladen werden')
  }
}

export function compareNested(obj1: any, obj2: any): any {
  const result: any = {}
  const keys = Object.keys(obj1)
  // top level keys
  for (const key of keys) {
    if (obj1[key] !== obj2[key]) {
      // nested key on second level
      if (typeof obj1[key] === 'object') {
        const nestedObj1: any = obj1[key]
        const nestedObj2: any = obj2[key] || ''
        if (!isEqual(nestedObj1, nestedObj2)) {
          result[key] = nestedObj1
        }
      } else {
        result[key] = obj1[key]
      }
    }
  }
  return result
}

export function getKeyByValue(object: any, value: string): string {
  return Object.keys(object).find(key => object[key] === value) || value
}

export function structuredGoogleLocation(
  place: google.maps.places.PlaceResult
) {
  const location: Address = {
    location: {
      type: 'Point',
      coordinates: [
        place.geometry!.location.lng(),
        place.geometry!.location.lat()
      ]
    },
    zipCode: undefined,
    city: '',
    street: '',
    streetNo: '',
    countryCode: ''
  }

  place.address_components!.forEach(
    (component: google.maps.GeocoderAddressComponent) => {
      if (
        component.types.includes('locality') ||
        component.types.includes('postal_town')
      ) {
        location.city = component.long_name
      } else if (
        component.types.includes('street_address') ||
        component.types.includes('route')
      ) {
        location.street = component.long_name
      } else if (component.types.includes('street_number')) {
        location.streetNo = component.long_name
      } else if (component.types.includes('postal_code')) {
        location.zipCode = component.long_name
      } else if (component.types.includes('country') && component.short_name) {
        location.countryCode = component.short_name
      }
    }
  )

  return location
}
